<script>
import {mapActions} from "vuex";

export default {
  name: "OutputReservationDialog",
  components: {},
  mixins: [],
  props: {
    section: {
      type: String,
      required: true,
      default: () => null,
    },
    buttonClass: {
      type: String,
      default: () => null,
    },
    enableBlink: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      enableDialog: false,
      blinkingButton: false,
      page: 1,
      totalVisible: 7,
      tableHeaders: [
        { text: "受付日時", value: "created_at" },
        { text: "ステータス", value: "status_name", align: "center" },
        { text: "ファイル名", value: "file_name" },
        { text: "", value: "editable", align: "end" },
      ],
      outputFiles: [],
      pagination: {
        current_page: 1,
        total_count: 0
      },
    }
  },
  computed: {},
  watch: {
    enableDialog (val) {
      this.$emit("stopBlinkCallback")
      if (val) {
        this.reloadButtonClickEvent();
      }
    },
    enableBlink (val) {
      this.blinkingButton = val
    }
  },
  created() {},
  methods: {
    ...mapActions("AdminOutputFile", {
      fetchOutputFiles: "index",
      fetchOutputFile: "show",
    }),
    openDialogClickEvent () {
      this.enableDialog = true
    },
    cancelButtonClickEvent () {
      this.enableDialog = false
    },
    downloadButtonClickEvent (item) {
      this.fetchOutputFile({id: item.id}).then((content) => {
        this.downloadResource(content.url)
      })
    },
    reloadButtonClickEvent () {
      this.page = 1
      this.searchOutputFiles()
    },
    pageChangeEvent () {
      this.searchOutputFiles()
    },
    searchOutputFiles () {
      this.outputFiles = []
      const conditions = {
        section: this.section,
        page: this.page,
      }
      this.fetchOutputFiles({conditions: conditions}).then((content) => {
        this.outputFiles = content.output_files
        this.pagination = content.pagination
      })
    },
    /**
     * ファイルのダウンロード処理
     * @param url
     */
    downloadResource(url) {
      window.open(url, "reportTab");
    }
  },
}
</script>

<template>
  <div :class="buttonClass">
    <v-btn
      :class="blinkingButton ? 'blinkButton' : ''"
      @click="openDialogClickEvent"
    >
      <v-icon>mdi-download</v-icon>&nbsp;出力履歴
    </v-btn>
    <v-dialog
      v-model="enableDialog"
      width="1000"
      scrollable
    >
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>出力履歴一覧</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            @click="reloadButtonClickEvent"
          >
            <v-icon>
              mdi-reload
            </v-icon>
            再読み込み
          </v-btn>
        </v-card-actions>
        <v-card-text style="height: 400px">
          <v-data-table
            :headers="tableHeaders"
            :items="outputFiles"
            :items-per-page="-1"
            disable-sort
            fixed-header
            hide-default-footer
            height="370px"
          >
            <!-- ダウンロード -->
            <template v-slot:[`item.editable`]="{ item }">
              <v-btn
                v-if="item.status === 'completed'"
                small
                class="info"
                @click="downloadButtonClickEvent(item)"
              >
                <v-icon>
                  mdi-file-download
                </v-icon>
                ダウンロード
              </v-btn>
            </template>

          </v-data-table>
        </v-card-text>
        <v-card-text>
          <v-row dense>
            <v-col>
              <v-pagination
                v-model="page"
                :length="pagination.total_pages"
                :total-visible="totalVisible"
                circle
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="pageChangeEvent"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="cancelButtonClickEvent">キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
